// extracted by mini-css-extract-plugin
var _1 = "NewsboardPostFooter-moduleNewsboardPostFooter__BHDN8";
export { _1 as "NewsboardPostFooter" }
